export default "__VITE_ASSET__B6vG$ZGX__"